// This file was automatically generated from service.banner.html.
// Please don't edit this file by hand.

goog.provide('el8.template.service.banner');

goog.require('soy');
goog.require('soy.StringBuilder');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.service.banner.content = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div id="page-banner" class="', (opt_data.color == 'teal') ? 'chartBannerTealContainer' : 'chartBannerContainer', '"><div class="chartBannerText"><span class="banner-contents el8RightIndent"></span><span class="banner-buttons"></span></div></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.service.banner.button = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<button type="button" class="el8AloneButton el8ShortcutBarButton" name="', soy.$$escapeHtml(opt_data.name), '">', soy.$$escapeHtml(opt_data.caption), '</button> ');
  if (!opt_sb) return output.toString();
};
